// Contrat éditorial strict pour masquer des cartes de compléments uniquement
// dans l'app cliente. La source consultation.supplements et le Word restent
// inchangés. Aucune décision clinique n'est prise ici : Anissa choisit les IDs.

const ALLOWED_KEYS = new Set(["version", "excluded_item_ids"]);
const MAX_EXCLUSIONS = 64;

function cleanItemId(value) {
  if (typeof value !== "string") return null;
  const id = value.trim();
  return id && id.length <= 120 && /^[a-z0-9][a-z0-9-]*$/i.test(id) ? id : null;
}

export function parseSupplementEditorialOverride(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  if (Object.keys(value).some((key) => !ALLOWED_KEYS.has(key))) return null;
  if (value.version !== 1 || !Array.isArray(value.excluded_item_ids)
      || value.excluded_item_ids.length > MAX_EXCLUSIONS) return null;
  const ids = [];
  const seen = new Set();
  for (const raw of value.excluded_item_ids) {
    const id = cleanItemId(raw);
    if (!id) return null;
    if (!seen.has(id)) {
      seen.add(id);
      ids.push(id);
    }
  }
  return { version: 1, excluded_item_ids: ids };
}

export function createSupplementEditorialOverride(excludedItemIds = []) {
  const parsed = parseSupplementEditorialOverride({
    version: 1,
    excluded_item_ids: excludedItemIds,
  });
  if (!parsed) throw new Error("Sélection de compléments invalide.");
  return parsed;
}

export function applySupplementEditorialOverride(groups, value) {
  if (value === null || value === undefined) return groups;
  const parsed = parseSupplementEditorialOverride(value);
  // Toute métadonnée présente mais invalide bloque explicitement le mapping
  // et donc la publication. Un tableau vide serait ambigu pour les autres
  // consommateurs qui n'affichent pas le diagnostic de la modale.
  if (!parsed) throw new Error("Compléments à valider Anissa.");
  if (parsed.excluded_item_ids.length === 0) return groups;
  const normalizedGroups = Array.isArray(groups) ? groups : [];
  const currentIds = new Set(normalizedGroups.flatMap((group) => (
    Array.isArray(group?.items)
      ? group.items.map((item) => String(item?.id || "")).filter(Boolean)
      : []
  )));
  if (parsed.excluded_item_ids.some((id) => !currentIds.has(id))) {
    // Une carte source modifiée change de fingerprint. Ne jamais laisser son
    // ancien ID devenir une exclusion silencieusement inopérante.
    throw new Error("Compléments à valider Anissa : exclusion périmée.");
  }
  const excluded = new Set(parsed.excluded_item_ids);
  return normalizedGroups
    .map((group) => ({
      ...group,
      items: (Array.isArray(group?.items) ? group.items : [])
        .filter((item) => !excluded.has(String(item?.id || ""))),
    }))
    .filter((group) => group.items.length > 0);
}
